export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'USER-MANAGEMENT': {
    ADD_USER_TITLE: 'Añadir nuev@ usuari@',
    EDIT_USER_TITLE: 'Editar usuari@',
    TITLE: 'Gestión de usuari@s',
    TABLE: {
      TITLE: 'Listado de usuari@s',
      FILTERS: {
        SEARCH: 'Buscar',
        SEARCH_PLACEHOLDER: 'Buscar por nombre o correo electrónico',
      },
      HEADER: {
        FULL_NAME: 'Nombre y apellidos',
        EMAIL: 'Correo electrónico',
        LOCALE: 'Idioma',
        ROLES: 'Rol',
        SCOPED_LOCATIONS: 'Sucursales',
        SCOPED_OFFERS: 'Ofertas',
        ENABLED: 'Habilitado',
        ADDED_BY: 'Añadido por',
        CREATED_AT: 'Fecha',
        CREATED_AT_TOOLTIP: 'Fecha en la que se añadió al usuario',
        ACTIONS: 'Acciones',
      },
      BODY: {
        GROUP_USER_PERMISSIONS: {
          OWNER: 'Propietari@',
          ADMIN: 'Administrador\/a',
          PUBLISHER: 'Gestor\/a de ofertas',
          CANDIDATE_MANAGER: 'Gestor\/a de candidat@s',
          PUBLISHER_CANDIDATE_MANAGER: 'Gestor\/a de ofertas y candidat@s',
          GUEST: 'Invitad@',
          PLATFORM_ADMIN: 'Administrador\/a de plataforma',
          PLATFORM: 'Plataforma',
          UNDEFINED: 'No definido',
        },
        SCOPED_ALL: 'Todas',
        SCOPED_TOOLTIP: 'Alcance de permisos de usuari@',
      },
      ACTIONS: {
        DELETE: 'Eliminar',
        MANAGE_PERMISSIONS: 'Gestionar permisos',
      },
      NO_DATA: 'No hay datos disponibles',
    },
    DELETE_USER: {
      CONFIRM_DELETE: {
        HEADER: 'Eliminar usuari@',
        MESSAGE: 'Esta persona perderá acceso a toda la plataforma.<br>¿Deseas continuar?',
        ACCEPT: 'Eliminar',
        REJECT: 'Cancelar',
      },
      SUCCESS_DELETE: {
        HEADER: 'Usuari@ eliminad@',
        MESSAGE: 'Usuari@ ha sido eliminad@ con éxito.',
      },
    },
    PERMISSIONS_MODAL: {
      TITLE: 'Gestionar Permisos',
      DESCRIPTION: 'Los permisos determinan qué acciones pueden realizar l@s usuari@s en la plataforma; y estas pueden ser tan específicas como el acceso a una sola oferta o sucursal.',
      CURRENT_PERMISSIONS: 'Permisos Actuales',
      NO_PERMISSIONS: 'Usuari@ no tiene permisos asignados aún.',
      NO_PERMISSIONS_REQUIRED: 'Debes añadir al menos un permiso antes de guardar.',
      ADD_PERMISSION: 'Añadir Nuevo Permiso',
      SCOPE_TYPE: {
        ENTITY: 'Toda la Empresa',
        LOCATION: 'Por Sucursal',
        ENTITY_LOCATION: 'Por Sucursal', // Fallback para variante del backend
        OFFER: 'Oferta Específica',
      },
      TABLE: {
        SCOPE_TYPE: 'Tipo de Alcance',
        ENTITY_NAME: 'Nombre',
        STATUS: 'Estado',
        ACTIONS: 'Acciones',
        REMOVE: 'Eliminar permiso',
      },
      VALIDATION: {
        VALID: 'Válido',
        REDUNDANT: 'Redundante',
        REASON: 'Razón',
        SUMMARY_WARNING: '⚠️ {{redundant}} de {{total}} roles no se guardarán por ser redundantes según la jerarquía (Empresa > Sucursal > Oferta).',
        VALIDATING: 'Validando permisos...',
        ERROR: 'No se pudo validar los permisos. Puede continuar guardando bajo su responsabilidad.',
        REDUNDANT_BY_ENTITY: 'Cubierto por permiso de toda la empresa: {{entity_name}}',
        REDUNDANT_BY_LOCATION: 'Cubierto por permiso de sucursal: {{location_name}}',
        ERROR_MISSING_GROUP: 'Error: falta identificador de grupo',
        ERROR_INVALID_SCOPE: 'Error: definición de scope inválida',
        REDUNDANT_GENERIC: 'Cubierto por un permiso de mayor alcance',
      },
      ENTITY_LEVEL_ALL: 'Toda la empresa',
      FORM: {
        SCOPE_TYPE: 'Tipo de Alcance',
        SELECT_SCOPE_TYPE: 'Seleccione el tipo de alcance',
        LOCATION: 'Sucursal',
        SELECT_LOCATION: 'Selecciona una sucursal',
        OFFER: 'Oferta',
        SEARCH_OFFER: 'Selecciona una oferta',
        NO_OFFER_RESULTS: 'No se encontraron ofertas',
        OFFER_HINT: 'Escriba al menos 3 caracteres para buscar',
        ADD_BUTTON: 'Añadir Permiso',
      },
      DUPLICATE_WARNING: {
        HEADER: 'Permiso Duplicado',
        MESSAGE: 'Este permiso ya está asignado.',
      },
      SUCCESS: {
        HEADER: 'Permisos Actualizados',
        MESSAGE: 'Los permisos se han actualizado correctamente.',
      },
      ERROR: {
        HEADER: 'Error al Guardar',
        MESSAGE: 'Ha ocurrido un error al guardar los permisos. Por favor, inténtelo de nuevo.',
      },
    },
    CONFIRM_MODAL: {
      TITLE: '⚠️ Hay roles solapados que debes corregir',
      DESCRIPTION: 'El sistema de permisos funciona por jerarquía: si asignas acceso a toda la Empresa, los permisos de Sucursal u Oferta que hayas añadido quedan cubiertos y son innecesarios. Lo mismo ocurre si asignas una Sucursal: los permisos de Ofertas de esa sucursal quedan redundantes. Debes eliminar los roles marcados en amarillo antes de poder guardar.',
      WARNING: 'Tienes {{redundant}} rol(es) redundante(s) de un total de {{total}}. Elimínalos para continuar.',
      VALID_ROLES_TITLE: 'Roles válidos (se guardarán)',
      REDUNDANT_ROLES_TITLE: 'Roles redundantes (debes eliminarlos)',
      REASON: 'Por qué es redundante',
      SAVE_ANYWAY: 'Guardar de todas formas',
      GO_BACK: 'Volver y corregir',
    },
    ASSIGN_PERMISSIONS: {
      PAGE_TITLE: 'Gestión de usuari@s',
      STEP_LABEL: 'Paso 2 · Rol y permisos',
      ENTITY_SCOPE_LABEL: 'Acceso completo',
      ENTITY_SCOPE_DESCRIPTION: 'Al activar esta opción, el/la usuari@ tendrá acceso a todas las sucursales y ofertas según su rol.',
      ENTITY_SCOPE_DESCRIPTION_ITALIC: 'Desactívala para configurar permisos específicos en la siguiente sección.',
      ENTITY_SCOPE_CONFIRM: {
        HEADER: 'Activar acceso completo',
        MESSAGE: 'Si activas esta opción, se eliminarán los permisos configurados previamente, y ahora el/la usuari@ tendrá acceso a todas las sucursales y ofertas disponibles, según los permisos de su rol asignado.',
        ACCEPT: 'Continuar',
        REJECT: 'Cancelar',
      },
      SPECIFIC_PERMISSIONS_TITLE: 'Permisos específicos',
      SPECIFIC_PERMISSIONS_DESCRIPTION: 'El/la usuari@ solo tendrá acceso a las sucursales y ofertas que selecciones a continuación.',
      ADD_PERMISSION_SECTION: 'Añadir permiso',
      CONFIGURED_PERMISSIONS: 'El/la usuari@ tiene acceso a:',
      // Wizard: paso ciudad
      SELECT_CITY: 'Selecciona una ciudad',
      CITY_LABEL: 'Ciudad',
      // Wizard: paso sucursal
      SELECT_LOCATION: 'Selecciona una sucursal',
      LOCATION_LABEL: 'Sucursal',
      SELECT_ALL: 'Todas',
      ALL_LOCATIONS_IN_CITY: 'Todas las sucursales de {{city}}',
      // Wizard: paso ofertas
      SELECT_OFFERS_FOR_LOCATION: 'Selecciona ofertas',
      ALL_OFFERS_IN_LOCATION: 'Todas las ofertas de esta sucursal',
      ALL_LOCATIONS: 'Todas las sucursales',
      ALL_OFFERS: 'Todas las ofertas',
      OFFER_LABEL: 'Oferta',
      CONFIRM_OFFERS: 'Confirmar selección',
      // Wizard: controles
      WIZARD_CANCEL: 'Cancelar',
      WIZARD_IN_PROGRESS: 'Completa o cancela la selección en curso antes de guardar',
      // Eliminar card
      REMOVE_PERMISSION: 'Eliminar permiso',
      REMOVE_PERMISSION_CONFIRM: {
        HEADER: 'Eliminar permiso',
        MESSAGE: '¿Confirmas que quieres revocar este permiso?',
        ACCEPT: 'Sí, eliminar',
        REJECT: 'Cancelar',
      },
      GLOBAL_ACCESS_BLOCKED_TOOLTIP: 'Este rol tiene acceso completo, no es posible desactivar esta opción',
      // Etiquetas de las cards de permisos
      CARD_OFFER: 'Oferta',
      CARD_DATA: 'Datos',
      CARD_LOCATION: 'Sucursal',
      CARD_CITY: 'Ciudad',
      CARD_PUBLISHED: 'Publicada',
      LEAVE_CONFIRM: {
        HEADER: 'Usuari@ necesita permisos',
        MESSAGE: 'Si sales ahora, usuari@ quedará cread@ pero sin permisos asignados. ¿Deseas salir de todas formas?',
        ACCEPT: 'Sí, salir',
        REJECT: 'Continuar configurando',
      },
    },
    FORM_USER: {
      FOOTER: 'Al invitar, el/la usuari@ recibirá un correo con sus credenciales de acceso.',
      FOOTER_EDIT: 'Al guardar, el/la usuari@ recibirá un correo con sus credenciales de acceso.',
      FOOTER2: 'Si no lo encuentra en su bandeja principal, pídele que revise la carpeta de spam.',
      BUTTONS: {
        SAVE: 'Guardar',
        INVITE: 'Invitar',
        CONTINUE: 'Continuar',
        CANCEL: 'Cancelar',
        DELETE: 'Eliminar',
        BACK: 'Volver',
        GO_TO_GENERAL_DATA: 'Datos generales',
      },
      SCOPE_INFO: {
        DESCRIPTION: 'Por defecto, el alcance de los permisos será para toda la empresa. Si deseas restringirlos por sucursal u oferta, marca la casilla.',
        RESTRICT_CHECKBOX: 'Restringir permisos por sucursal u oferta',
      },
      PERMISSION_DEFAULT_CONFIRM: {
        HEADER: 'Sin permisos configurados',
        MESSAGE: 'Has cerrado sin guardar ningún permiso. Si continúas, se asignará automáticamente el acceso a toda la empresa. ¿Deseas continuar o volver a configurar los permisos?',
        ACCEPT: 'Sí, asignar acceso completo',
        REJECT: 'Volver a permisos',
        SUCCESS: 'Se ha asignado el acceso a toda la empresa por defecto.',
      },
      FIELDS: {
        FIRSTNAME: {
          LABEL: 'Nombre',
          PLACEHOLDER: 'Introduzca el nombre',
        },
        LASTNAME: {
          LABEL: 'Apellidos',
          PLACEHOLDER: 'Introduzca los apellidos',
        },
        EMAIL: {
          LABEL: 'Correo electrónico',
          PLACEHOLDER: 'Introduzca el correo electrónico',
        },
        LOCALE: {
          LABEL: 'Idioma',
          PLACEHOLDER: 'Seleccione el idioma',
          OPTIONS: {
            EN: 'Inglés',
            ES: 'Español',
          },
        },
        GROUP: { LABEL: 'Rol', PLACEHOLDER: 'Selecciona un rol', ROLE_READONLY_TOOLTIP: 'Para cambiar el rol, ve a la siguiente pantalla presionando el botón Continuar' },
        ENABLED: { LABEL: 'Habilitado' },
      },
      SUCCESS_EDIT: {
        HEADER: 'Usuari@ actualizad@',
        MESSAGE: 'Usuari@ ha sido actualizad@ con éxito.',
      },
      MESSAGES: {
        USER_CREATED: 'Usuari@ cread@ con éxito. Se ha enviado un correo de invitación.',
        USER_UPDATED: 'Usuari@ actualizad@ con éxito.',
      },
      CROP_IMAGE: {
        TITLE: 'Recortar imagen',
        CONFIRM: 'Aplicar recorte',
      },
      ERRORS: {
        USER_NOT_FOUND: 'Usuari@ no encontrad@',
        NOT_AUTHORIZED: 'No autorizado para eliminar usuari@s',
        EMAIL_NOT_BLANK: 'El correo electrónico no puede estar vacío',
        EMAIL_NOT_VALID: 'El correo electrónico no es válido',
        EMAIL_ALREADY_EXISTS: 'El correo electrónico ya está en uso',
        FIRSTNAME_NOT_BLANK: 'El nombre no puede estar vacío',
        LASTNAME_NOT_BLANK: 'Los apellidos no pueden estar vacíos',
        ENABLED_NOT_BLANK: 'El estado habilitado no puede estar vacío',
        ENABLED_NOT_BOOL: 'El estado habilitado debe ser verdadero o falso',
        LOCALE_NOT_VALID: 'El idioma no es válido',
        UNKNOWN_ERROR: 'Ha ocurrido un error inesperado. Por favor, inténtelo de nuevo.',
      },
    },
  },
} as const;
